<template>
  <div>
    <h3>TPC Co-Chairs</h3>
    <el-table
        :data="chairData"
        stripe
        :show-header=false
        max-height="300"
        style="width: 100%">
      <el-table-column
          prop="name"
          label="Chair Name">
      </el-table-column>
      <el-table-column
          prop="organization"
          label="Organization">
      </el-table-column>
    </el-table>

    <h3>TPC Members</h3>
    <el-table
        :data="member"
        stripe
        :show-header=false
        max-height="1500"
        style="width: 100%">
      <el-table-column
          prop="name"
          label="Member Name">
      </el-table-column>
      <el-table-column
          prop="organization"
          label="Organization">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chairData: [{
        name: 'Lei Yang',
        organization: 'South China University of Technology, China'
      }, {
        name: 'Wei Cai',
        organization: 'The Chinese University of Hong Kong, Shenzhen, China'
      }],
      member: [{
        name: 'Abhishek Roy',
        organization: 'University of Burdwan, India'
      }, {
        name: 'Han Qiu',
        organization: 'Tsinghua University, China'
      }, {
        name: 'Hui Cheng',
        organization: 'University of Hertfordshire, U.K.'
      }, {
        name: 'Janick Edinger',
        organization: 'Universität Hamburg, Germany'
      }, {
        name: 'Jianguo Wang',
        organization: 'Purdue University, U.S.'
      }, {
        name: 'Jianwei Kang',
        organization: 'Nanyang Technological University, Singapore'
      }, {
        name: 'Long Cheng',
        organization: 'North China Electric Power University, China'
      }, {
        name: 'Md Osman Gani',
        organization: 'University of Maryland, Baltimore County'
      }, {
        name: 'Navrati Saxena',
        organization: 'Sungkyunkwan University, South Korea'
      }, {
        name: 'Pan Zhou',
        organization: 'Huazhong University of Science and Technology, China'
      }, {
        name: 'Shaojie Tang',
        organization: 'The University of Texas at Dallas, U.S.'
      }, {
        name: 'Suman Bhunia',
        organization: 'Miami University of Ohio, U.S.'
      }, {
        name: 'Wanyu Lin',
        organization: 'The Hong Kong Polytechnic University, Hong Kong'
      }, {
        name: 'Xiaohua Xu',
        organization: 'University of Science and Technology of China, China'
      }, {
        name: 'Yang Wang',
        organization: 'Shenzhen Institute of Advanced Technology, CAS, China'
      }, {
        name: 'Zehua Wang',
        organization: 'The University of British Columbia, Vancouver, Canada'
      }, {
        name: 'Zehui Xiong',
        organization: 'Singapore University of Technology and Design, Singapore'
      }, {
        name: 'Zhenhua Li',
        organization: 'Tsinghua University, China'
      }, {
        name: 'Zongjian He',
        organization: 'The University of Auckland, New Zealand'
      }]
    }
  }
}
</script>